export { default as withOnlyProjectAdmin } from './with-only-project-admin';
